export const CARD_PADDING = 16;
export const SCROLLBAR_RIGHT_OFFSET = 15;
export const PAGE_TITLE_HEIGHT = 40;
export const ENGAGEMENT_BAR_HEIGHT = 80;
export const FOOTER_HEIGHT = 65;

// When screen is small, the navigation gets on top and is sticky.
// It's height is dependent on screen width and number of sections.
// scroll-padding-top feature is not worth doing perfect calculations.
export const AVERAGE_FULL_SIZE_NAVIGATION_HEIGHT = 150;
